module.exports = __webpack_public_path__ + "static/media/run-icon.0aabb7b0.svg";